import React, { } from 'react'
import './Header.css'

class Header extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount () {
  }

  showClass (page) {
    if ((window.location.host + page)  
          === (window.location.host + window.location.pathname)) {
      return 'hideNavItem'
    } else {
      return ''
    }
  }

  render () {
    return (
      <div className='fixedHeaderContainer'>
        <div className='headerWrapper wrapper'>
          <header>
            <a href='/'><img className='logo' src='https://lushplans.com/img/logo_color.png' alt='Lush Plans' />
              <h2 className='headerTitleWithLogo'>Lush Plans</h2></a>
            <div className='navigationWrapper navigationSlider'>
              <nav className='slidingNav'>
                <ul className='nav-site nav-site-internal'>
                  <li className={this.showClass('')}><a href='/' target='_self'>FAQ</a></li>
                  <li className={this.showClass('')}><a href='https://lushplans.com/app/#!/profile' target='_self'>Couples</a></li>
                  <li className={this.showClass('/') || this.showClass('/list')}><a href='./list' target='_self'>Vendors</a></li>
                  <li className=''><a id='vendor-cta' href='https://vendor.lushplans.com/'>Claim your vendor profile</a></li>
                </ul>
              </nav>
            </div>
          </header>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/Header/Header.js